import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { baseGrid, SitePadding, SiteWidth } from '@helpers/grid';
import { Device, from, until } from '@helpers/media';
import { h5, tag } from '@helpers/typography';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import { m } from 'framer-motion';
import { mix } from 'polished';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  --accentColor: ${brand.blue.base};
  --bgColor: ${mix(0.25, brand.grey.otherGrey, brand.white)};
  --fgColor: ${brand.black};
  --padding: 48px;

  color: var(--fgColor);

  @media ${from(Device.Tablet)} {
    /* Use background to fill in the right-side gutter */
    --siteContainerWithPadding: ${SiteWidth}px + ${SitePadding}px + ${SitePadding}px;
    --siteMargin: calc(100vw - var(--siteContainerWithPadding));
    --siteMarginRight: calc(var(--siteMargin) / 2);

    background-image: linear-gradient(to right, var(--bgColor), var(--bgColor));
    background-repeat: no-repeat;
    background-position: right;
    background-size: max(18px, var(--siteMarginRight)) 100%;
  }

  @media ${from(Device.TabletLarge)} {
    --padding: 96px;
  }

  @media ${from(Device.DesktopSmall)} {
    --padding: 120px;
  }
`;
const Inner = styled(m.div) `
  ${baseGrid};
  align-items: flex-start;
  width: 100%;

  @media ${until(Device.Tablet)} {
    grid-template-rows: none;
  }

  @media ${from(Device.Tablet)} {
    grid-template-rows: auto 1fr;
  }

  @media ${from(Device.TabletLarge)} {
    grid-template-rows: none;
  }
`;
const MetaWrapper = styled(m.div) `
  display: flex;
  flex-direction: column;

  @media ${until(Device.Tablet)} {
    gap: 12px;
    grid-column: 1 / span 12;
    padding-top: var(--padding);
  }

  @media ${from(Device.Tablet)} {
    gap: 24px;
    grid-column: 1 / span 8;
    grid-row: 1;
    padding-top: var(--padding);
    padding-right: var(--sitePadding);
  }

  @media ${from(Device.TabletLarge)} {
    position: sticky;
    top: var(--headerHeight);
    grid-column: 1 / span 2;
    grid-row: 1;
    padding: var(--padding) 0;
  }
`;
const Tag = styled.span `
  ${tag}
  display: block;
  color: var(--accentColor);
`;
const Date = styled.time `
  display: block;
  ${fonts.helvetica.regular};
  font-size: 18px;
  letter-spacing: -0.01em;
  line-height: 1em;
`;
const ContentWrapper = styled(m.div) `
  display: flex;
  flex-direction: column;
  max-width: 770px;

  @media ${until(Device.Tablet)} {
    gap: 40px;
    grid-column: 1 / span 12;
    padding: var(--padding) 0;
  }

  @media ${from(Device.Tablet)} {
    gap: 72px;
    grid-column: 1 / span 8;
    grid-row: 2;
    padding: var(--padding) 0;
    padding-right: var(--sitePadding);
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 3 / span 7;
    grid-row: 1;
    padding: var(--padding) 0;
    padding-right: var(--sitePadding);
  }
`;
const RelatedCarousel = styled.div `
  @media ${from(Device.Tablet)} {
    display: none;
  }
`;
const RelatedWrapper = styled(m.div) `
  display: flex;
  flex-direction: column;

  @media ${until(Device.Tablet)} {
    display: none;
  }

  @media ${from(Device.Tablet)} {
    position: relative;
    align-self: stretch;
    background: var(--bgColor);
    grid-column: 9 / span 4;
    grid-row: 1 / span 2;
    justify-self: flex-end;
    padding: var(--padding) 0;
    padding-left: var(--gutterWidth);
    width: calc(100% + var(--gutterWidth));
  }

  @media ${from(Device.TabletLarge)} {
    grid-column: 10 / span 3;
    grid-row: 1;
  }
`;
const RelatedTitle = styled(m.h2) `
  ${h5};
  margin-bottom: 48px;
`;
const RelatedItem = styled(m.div) `
  &:not(:last-child) {
    margin-bottom: 48px;
  }

  @media ${from(Device.Tablet)} {
    &:not(:last-child) {
      margin-bottom: 108px;
    }
  }
`;
const MediaDetailContentSectionStyles = {
    Container,
    ContentWrapper,
    Date,
    Inner,
    MetaWrapper,
    RelatedCarousel,
    RelatedItem,
    RelatedTitle,
    RelatedWrapper,
    Tag,
};
export default MediaDetailContentSectionStyles;
